import { z } from 'zod';

export const zodReprocessInvoiceEndpointSchema = z.tuple([
  z.literal('invoice'),
  z.literal('process'),
  z.uuid(),
  z.literal('reprocess'),
]);
